import React from 'react'

export const ScrollDown = () => {
  return (
    <div className="home_scroll_container">
        <a href="#About"  className='home_scroll button--flex'>
            <i className='bx bxs-chevrons-down bx-fade-down' ></i>
              Scroll down
        </a>
    </div>
  )
}
